"use client"

/** Shared logout confirmation — used by both DashboardSidebar and NotificationJobSidebar so the two
 *  sidebars' Logout buttons behave identically. */
export function LogoutConfirmDialog({ onCancel, onConfirm, loading }: { onCancel: () => void; onConfirm: () => void; loading?: boolean }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-[var(--db-dialog-bg)] rounded-xl shadow-xl p-6 w-80 flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <h3 className="text-[15px] font-semibold text-[var(--db-dialog-text)]">Log out?</h3>
          <p className="text-[13px] text-[var(--db-dialog-text-muted)]">
            You&apos;ll need to sign in again to access your account.
          </p>
        </div>
        <div className="flex gap-2 justify-end">
          <button
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2 text-[13px] font-medium text-[var(--db-dialog-text)] hover:bg-[var(--db-surface-hover)] disabled:opacity-50 rounded-lg transition-colors"
            style={{ backgroundColor: "var(--db-tag-bg)" }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="px-4 py-2 text-[13px] font-medium text-white bg-red-500 hover:bg-red-600 disabled:opacity-50 rounded-lg transition-colors"
          >
            {loading ? "Logging out…" : "Logout"}
          </button>
        </div>
      </div>
    </div>
  )
}
